import { render, staticRenderFns } from "./JD.vue?vue&type=template&id=77912723&scoped=true&"
import script from "./JD.vue?vue&type=script&lang=js&"
export * from "./JD.vue?vue&type=script&lang=js&"
import style0 from "./JD.vue?vue&type=style&index=0&id=77912723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77912723",
  null
  
)

export default component.exports